<ng-container *transloco="let t">
	<vis-ods-three-section-drawer-layout-component>
		<ng-container content>
			<div class="flex absolute bg-white w-full h-4xl">
				<vis-ods-icon-component
					(click)="openPrintDialog()"
					width="20"
					height="20"
					name="printer"
					class="fill-body absolute top-m left-m print:hidden"
				></vis-ods-icon-component>
				<vis-ods-icon-component
					data-test-id="remove-product"
					(click)="removeProductFromShoppingCart()"
					width="20"
					height="20"
					name="delete"
					class="fill-body absolute top-m left-5xl print:hidden"
				></vis-ods-icon-component>
			</div>

			<div *ngIf="order() as product; appLoadingAnimation">
				<app-product-summary
					class="block mt-4xl"
					[editShippingAddressEnabled]="true"
					(editShippingAddressRequested)="routeToShippingAddressSelector()"
					(editContactPersonRequested)="routeToContactPersonSelector()"
				></app-product-summary>
			</div>
		</ng-container>
		<div
			class="grid grid-cols-2 p-m bg-white items-center border-t border-separator print:hidden"
			footer
		>
			<button
				beyond-online-button
				variant="secondary"
				class="justify-center flex-grow first-letter:my-s mr-s"
				(click)="backToProductConfig()"
				[disabled]="$isLoading()"
				[label]="t('productSummary.buttons.edit')"
				[attr.data-testid]="'cart-item-edit-button'"
			></button>
			<button
				[disabled]="!(rolesEnum.Buyer | userPermission) || isBlockedFromOrdering()"
				class="justify-center flex-grow first-letter:my-s"
				beyond-online-button
				variant="primary"
				[loading]="$isLoading()"
				(click)="submitOrder()"
				[label]="t('productSummary.buttons.orderNow')"
			></button>
			@if (isBlockedFromOrdering()) {
				<span class="text-body text-sm col-span-full text-end">
					{{
						t('generalComponents.blockedFromOrderingToast.texts.message', {
							date: blockRemoveDate | dateTimeFormat,
						})
					}}
				</span>
			}
		</div>
	</vis-ods-three-section-drawer-layout-component>
</ng-container>
